/**
 * 个性化配置相关国际化文本 - 中文
 */
export default {
  title: '个性化配置',
  readonlyNotice: '当前账号为普通用户，仅可查看配置。如需修改，请联系租户管理员。',
  tabs: {
    portal: 'Portal 企业门户展示',
    cargowareX: 'CargoWare X 系统界面'
  },
  cargowareX: {
    description: '配置 CargoWare X 管理系统内的系统品牌与控制塔助手',
    systemUi: {
      title: '系统界面配置',
      logoLabel: '系统 Logo',
      logoSubLabel: '（左侧导航栏显示）',
      logoTip: '左侧导航栏显示；建议尺寸 200×60 px',
      logoUpload: '点击上传 Logo',
      logoSizeHint: '建议比例：10:3',
      iconLabel: '系统图标',
      iconSubLabel: '（浏览器标签页图标）',
      iconTip: '浏览器标签页图标；建议尺寸 64×64 px（1:1）',
      iconUpload: '点击上传图标',
      iconSizeHint: '建议比例：1:1',
      titleLabel: '系统标题',
      titleSubLabel: '（浏览器标签页和系统顶部显示）',
      titlePlaceholder: '请输入系统标题（最多 100 个字符）',
      titleTip: '浏览器标签页和系统顶部显示',
      replace: '更换',
      crop: '裁剪',
      remove: '删除',
      cropLogoTitle: '裁剪系统 Logo',
      cropIconTitle: '裁剪系统图标',
      cropAreaAria: '可调整的裁剪区域',
      cropSize: '当前裁剪尺寸：{w} × {h} px',
      cropLogoRatio: '建议比例：10:3',
      cropIconRatio: '建议比例：1:1',
      cropTip: '拖动裁剪框四角调整范围，确认后仅保存裁剪结果。',
      cropSuccess: '裁剪结果已保存'
    },
    assistant: {
      title: '控制塔助手',
      switchLabel: '显示控制塔助手',
      tip: '控制系统顶部控制塔助手入口的显示'
    },
    messages: {
      saveSuccess: '系统界面配置已保存',
      saveFail: '系统界面配置保存失败',
      saveNeedPortalConfig: '请先保存网站基本信息配置后再保存系统界面',
      versionMissing: '数据版本号不能为空，请刷新页面后重试',
      uploadSuccess: '上传成功',
      uploadFail: '图片上传失败',
      uploadTooLarge: '图片大小不能超过 5MB',
      uploadNotImage: '请上传图片文件',
      uploadDimensionMismatch: '图片尺寸不符，请规范合适尺寸后重新上传'
    },
    help: {
      systemLogo: '影响 CargoWare X 系统左侧导航栏中显示的 Logo。',
      systemIcon: '影响 CargoWare X 系统浏览器标签页中显示的图标。',
      systemTitle: '影响 CargoWare X 系统浏览器标签页和顶部标题。',
      browser: '影响浏览器标签页中显示的网页标题和小图标。',
      browserTitle: '影响门户网站在浏览器标签页中显示的网页标题。',
      browserIcon: '影响门户网站在浏览器标签页中显示的小图标（Favicon）。',
      header: '影响门户首页顶部展示的企业 Logo。',
      slogan: '影响门户首屏展示的公司标语与描述。',
      previewSystemTitle: '首页 - CargoWare X',
      previewPortalTitle: '企业门户',
      navHome: '首页',
      navBpm: '事务中心',
      navBi: '统计分析',
      navOrder: '委托下单',
      breadcrumb: '首页 / 系统设置 / 个性化配置',
      portalNav: '优势 · 服务与网络 · 公司新闻',
      portalSlogan:
        'CargoWare X 致力于为全球客户提供可靠、高效的一体化物流服务，连接全球业务与合作伙伴。',
      aiTitle: 'Tenant Portal AI助手',
      aiStatus: '在线为您服务',
      aiGreeting: '您好！ CargoWare X 智能助手为您服务。',
      aiQuickTitle: '快捷问询',
      aiQuick1: '› 深圳到汉堡整箱运输多少钱',
      aiQuick2: '› 新客户怎么合作？',
      aiInput: '请输入内容'
    }
  },
  portalSection: {
    title: 'Portal 企业门户展示',
    description: '配置门户网站的展示内容、品牌信息与页面模块'
  },
  upgrade: {
    title: '升级解锁完整品牌能力',
    description:
      '当前使用标准门户，仅可配置网站皮肤和系统分配域名。升级 CargoWare X 可解锁自定义品牌、AI 和更多门户功能。',
    button: '升级到 CargoWare X'
  },
  generatedSource: {
    prefix: '内容自动生成自',
    headerLogo: '企业档案 > 基本信息 > Logo',
    slogan: '企业档案 > 关于我们 > 描述'
  },
  headerModule: {
    logoTitle: 'Header 区 Logo',
    sloganTitle: '公司标语',
    sloganContentLabel: '标语内容',
    logoPreviewAlt: 'Header Logo',
    logoPreviewEmpty: '暂无 Header Logo 图片，请确认个性化配置中已同步 Logo 文件',
    sloganPreviewEmpty: '暂无公司标语内容'
  },
  portalModules: {
    defaultHint: '此模块展示内容来源于企业档案，请前往企业档案进行配置。',
    serviceHighlights: {
      title: '服务亮点',
      contentHint:
        "内容自动生成自 <span class='module-source-link'>企业档案 &gt; 服务亮点</span>",
      empty: '企业档案中暂无服务亮点，请先前往企业档案配置',
      groupServices: '明星服务',
      groupPorts: '优势港口',
      groupRoutes: '优势航线'
    },
    serviceNetwork: {
      title: '服务能力与网络',
      contentHint:
        "内容自动生成自 <span class='module-source-link'>企业档案 &gt; 服务与覆盖</span>",
      empty: '企业档案中暂无服务与覆盖数据，请先前往企业档案配置'
    },
    companyNews: {
      title: '公司新闻',
      contentHint: '开启公司新闻后，可在个性化配置 > 公司新闻中编辑新闻内容'
    }
  },
  aiAgent: {
    title: 'AI 助手配置',
    enableLabel: '启用 AI 助手',
    enableDesc: '开启后，门户页面将展示 AI 助手，帮助访客获取业务信息',
    greetingLabel: 'AI 问候语',
    greetingTooltip: 'AI 助手首次打开时向访客展示的问候消息，最多200字',
    greetingPlaceholder: '请输入 AI 助手向访客展示的问候语...',
    defaultGreeting:
      '您好！我是您的智能助手。我可以帮您查询运价、了解航线以及我们的服务。今天有什么可以帮您？'
  },
  valuesAdvantages: {
    title: '核心价值与优势',
    description: '配置企业在门户页面展示的核心服务优势，最多可添加12张卡片。每张卡片支持图片、名称和描述。',
    addCard: '添加卡片',
    namePlaceholder: '服务名称',
    descPlaceholder: '简要描述...',
    uploadImage: '上传图片',
    changeImage: '更换图片',
    uploading: '上传中...',
    uploadNotImage: '请选择图片文件',
    uploadTooLarge: '图片大小不能超过5MB',
    uploadFail: '图片上传失败',
    maxCards: '最多添加 {max} 张卡片'
  },
  leads: {
    title: '客户线索获取',
    enableLabel: '启用客户线索获取表单',
    enableDesc: '开启后，门户页面将展示客户线索收集表单',
    formFieldsLabel: '表单字段预览',
    hint: '访客提交的信息将自动进入营销线索管理系统，可在「营销线索」模块中查看和跟进。',
    fields: {
      companyName: '公司名称',
      contactPerson: '联系人',
      email: '邮箱',
      phone: '电话',
      remark: '备注信息'
    }
  },
  browserTab: {
    title: '浏览器标签页设置',
    description: '自定义浏览器标签页的标题和图标',
    pageTitleLabel: '标签页标题',
    pageTitlePlaceholder: '请输入标签页标题',
    faviconLabel: '网站图标',
    faviconHint: '（浏览器标签页显示的小图标）',
    uploadFavicon: '点击上传',
    uploadSizeHint: '建议比例：1:1',
    replaceFavicon: '更换',
    cropFavicon: '裁剪',
    removeFavicon: '删除',
    cropTitle: '裁剪网站图标',
    cropAreaAria: '可调整的裁剪区域',
    cropSize: '当前裁剪尺寸：{w} × {h} px',
    cropRatioHint: '建议比例：1:1',
    cropTip: '拖动裁剪框四角调整范围，确认后仅保存裁剪结果。',
    cropSuccess: '裁剪结果已保存'
  },
  footer: {
    title: '页脚配置',
    description: '配置页面底部的 Logo、标语、法律信息和社交媒体',
    footerLogoLabel: '页脚 Logo',
    footerSloganLabel: '页脚标语',
    footerSloganPlaceholder: '请输入页脚标语',
  uploadLogo: '点击上传 Logo',
  replaceLogo: '更换',
  cropLogo: '裁剪',
  removeLogo: '删除',
  logoSizeHint: '建议比例：10:3',
  cropTitle: '裁剪页脚 Logo',
  cropAreaAria: '可调整的裁剪区域',
  cropSize: '当前裁剪尺寸：{w} × {h} px',
  cropRatioHint: '建议比例：10:3',
  cropTip: '拖动裁剪框四角调整范围，确认后仅保存裁剪结果。',
  cropSuccess: '裁剪结果已保存',
  legalInfo: '法律信息',
    copyrightLabel: '版权信息',
    copyrightPlaceholder: '例如：© 2024 Your Company. All rights reserved.',
    privacyPolicyLabel: '隐私政策链接',
    privacyPolicyPlaceholder: 'https://example.com/privacy',
    termsOfServiceLabel: '服务条款链接',
    termsOfServicePlaceholder: 'https://example.com/terms',
    socialMedia: '社交媒体',
    filingInfo: '注册与备案'
  },
  website: {
    description: '配置网站的基本信息和展示内容',
    skinSettings: {
      title: '网站皮肤设置',
      templateLabel: '网站模板',
      templateTooltip: '选择门户网站的视觉风格，不同模板会影响门户的配色',
      preview: '预览',
      previewSuffix: '风格预览',
      themes: {
        business: '简约商务',
        premium: '高端尊享',
        fresh: '清新现代',
        tech: '未来科技',
        custom: '自定义'
      },
      primaryColor: '品牌主色',
      primaryColorHint: '主要按钮、链接、选中状态和重点标题',
      accentColor: '强调色',
      accentColorHint: '标签、次级重点、装饰和渐变终点'
    },
    browserTab: {
      faviconLabel: '网站图标',
      faviconHint: '（浏览器标签页显示的小图标，建议 64×64）',
      upload: '上传图标',
      remove: '删除'
    },
    basicInfo: {
      title: '基础信息设置',
      domain: {
        label: '自定义域名设置',
        placeholder: '请输入域名前缀',
        suffix: '.walltechsystem.com',
        edit: '编辑',
        validate: '校验可用性',
        cancel: '取消',
        tip: '控制塔系统支持使用您自有域名，如有需要，请联系客服支持人员。',
        warning: {
          title: '域名修改提醒',
          message: '域名每6个月仅可修改一次，请慎重操作',
          note: '修改后将立即生效，请确保新域名符合您的需求',
          confirm: '确认要修改域名吗？',
          okText: '确认修改'
        },
        check: {
          title: '域名可用性检查',
          available: {
            title: '🎉 恭喜您，域名可用！',
            note: '点击"确认修改"完成域名设置'
          },
          unavailable: {
            title: '😞 抱歉，该域名已被使用',
            note: '请尝试其他域名前缀'
          }
        }
      },
      siteName: {
        label: '网站名称',
        placeholder: '请输入网站名称'
      },
      headerLogo: {
        label: 'Header区Logo设置',
        logoOnly: '单纯Logo',
        logoWithSlogan: 'Logo + 标语',
        upload: '上传Header Logo',
        sloganPlaceholder: '请输入Logo标语（选择Logo+标语时显示）',
        sloganDisabledHint: '选择"Logo + 标语"时可编辑标语',
        sloganTip: '标语将显示在Logo下方，建议控制在1-2行内'
      },
      footerLogo: {
        label: 'Footer区Logo设置',
        logoOnly: '单纯Logo',
        logoWithSlogan: 'Logo + 标语',
        upload: '上传Footer Logo',
        sloganPlaceholder: '请输入Logo标语（选择Logo+标语时显示）',
        sloganDisabledHint: '选择"Logo + 标语"时可编辑标语',
        sloganTip: '标语将显示在Logo下方，建议控制在1-2行内'
      },
      copyright: {
        label: '版权信息',
        placeholder: '请输入版权信息'
      },
      privacyPolicy: {
        label: '隐私政策链接',
        placeholder: '请输入隐私政策页面链接'
      },
      termsOfService: {
        label: '服务条款链接',
        placeholder: '请输入服务条款页面链接'
      }
    },
    socialMedia: {
      title: '社交媒体设置',
      platforms: {
        wechat: '微信',
        weibo: '微博',
        linkedin: 'LinkedIn',
        twitter: 'Twitter',
        facebook: 'Facebook',
        youtube: 'YouTube',
        instagram: 'Instagram',
        tiktok: 'TikTok'
      },
      types: {
        qr: '二维码',
        link: '跳转链接'
      },
      uploadQr: '上传二维码',
      linkPlaceholder: '请输入跳转链接',
      linkInputPlaceholder: '输入{name}链接'
    },
    filing: {
      title: '备案信息设置',
      miit: {
        label: 'ICP 备案号',
        placeholder: '例如：京ICP备12345678号'
      },
      miitDate: {
        label: 'ICP 备案日期'
      },
      police: {
        label: '公安备案号',
        placeholder: '例如：京公网安备11010102001234号'
      },
      policeDate: {
        label: '公安备案日期'
      }
    },
    contact: {
      title: '联系消息',
      sales: {
        title: '销售联系方式',
        email: {
          label: '销售邮箱',
          placeholder: '请输入销售邮箱'
        },
        phone: {
          label: '销售电话',
          placeholder: '请输入销售电话'
        }
      },
      service: {
        title: '客服联系方式',
        email: {
          label: '客服邮箱',
          placeholder: '请输入客服邮箱'
        },
        phone: {
          label: '客服电话',
          placeholder: '请输入客服电话'
        }
      },
      afterSales: {
        title: '售后联系方式',
        email: {
          label: '售后邮箱',
          placeholder: '请输入售后邮箱'
        },
        phone: {
          label: '售后电话',
          placeholder: '请输入售后电话'
        }
      }
    }
  },
  fields: {
    title: '页面字段配置',
    developing: '页面字段配置功能开发中...'
  },
  ai: {
    title: 'AI助手配置',
    developing: 'AI助手配置功能开发中...'
  },
  actions: {
    save: '保存配置',
    update: '更新配置',
    reset: '重置',
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    confirmModify: '确认修改'
  },
  messages: {
    saveSuccess: '保存成功',
    updateSuccess: '更新成功',
    switchSaveSuccess: '已自动保存',
    switchSaveNeedConfig: '请先保存门户配置后再使用自动保存',
    resetSuccess: '配置已重置为默认值',
    domainModifySuccess: '域名修改成功！',
    domainValidationError: '域名前缀至少4位字符，只能包含字母和数字',
    cancelChanges: '已取消更改',
    loadFail: '加载配置失败',
    saveFail: '保存配置失败',
    updateFail: '更新配置失败',
    resetFail: '重置配置失败',
    logoPreviewSuccess: 'Logo预览加载成功',
    logoPreviewFail: 'Logo预览创建失败',
    logoFileSelectFail: 'Logo文件选择失败',
    qrPreviewFail: '二维码预览创建失败',
    defaultSiteName: '物流控制塔系统'
  },
  domain: {
    title: '域名设置',
    freeAlert: '当前为公共域名版本，域名为系统自动分配，不可自定义。升级后可获得二级域名或自定义域名能力。',
    portalDomainLabel: '门户域名',
    /** 普通版 domainType=1：平台后缀下的二级域前缀 */
    subdomainLabel: '二级域名',
    /** 旗舰版 domainType=2：完整自有域名 */
    customDomainLabel: '自定义域名',
    subdomainPlaceholder: 'your-company',
    placeholder: 'portal.example.com',
    subdomainTip: '仅支持字母、数字和连字符，长度 2-63 字符',
    flagshipTip: '支持完整域名（如 portal.example.com），仅允许字母、数字、连字符和点号',
    assignedLabel: '系统分配域名',
    assignedFallback: '尚未分配门户地址',
    upgradeHint: '如需自定义域名，请联系平台运营升级域名配置类型。',
    verify: '校验域名',
    verifyAvailability: '校验可用性',
    verifySuccess: '域名校验通过（未被占用且连通正常）',
    verifyFail: '域名校验失败',
    copy: '复制',
    copySuccess: '域名已复制到剪贴板',
    copyFail: '复制失败，请手动复制',
    errors: {
      empty: '请输入域名',
      invalidFull: '请输入完整域名，例如 portal.example.com',
      invalidSubdomain: '请输入 2-63 位字母、数字或连字符组成的二级域名前缀'
    },
    guide: {
      aria: '查看 CargoWare X 域名用户手册',
      button: '用户手册',
      title: 'CargoWare X 域名用户手册',
      ok: '知道了',
      intro:
        '支持绑定完整自定义域名。请先在域名服务商处完成 DNS 配置，再返回本页校验。系统将检查域名是否已被其他租户使用，以及域名是否可以从公网正常访问。',
      step1Title: '1. 添加 DNS 记录',
      step1Body:
        '登录您的域名服务商，进入 DNS 管理页，按域名类型新增对应的解析记录，将要绑定的域名指向系统为本租户生成的平台接入地址。',
      dnsIngressLabel: '平台接入地址（记录值）',
      dnsIngressValue: '系统为本租户生成的地址',
      dnsSubdomainLabel: '子域名',
      dnsSubdomainValue: '类型：CNAME；主机记录：填写域名前缀',
      dnsWildcardLabel: '通配符域名',
      dnsWildcardValue: '类型：CNAME；主机记录：*',
      dnsRootLabel: '根域名',
      dnsRootValue: "按域名服务商支持的方式配置，主机记录通常为 {'@'}",
      copyDns: '复制 DNS 配置',
      copyDnsHint: '将平台接入地址粘贴到服务商的“记录值”字段。',
      copyDnsSuccess: 'DNS 配置已复制',
      step2Title: '2. 返回本页校验',
      step2Body:
        '完成配置并确认域名可以访问后，返回本页点击“校验可用性”。系统会检查：1）域名是否已被其他租户使用；2）域名是否可以从公网正常访问。',
      step3Title: '3. 根据结果处理',
      step3Body:
        '两项校验均通过后即可使用该域名；若校验失败，请先确认域名已正确解析并且可以从公网访问，再返回本页重试。',
      note: '完成 DNS 配置并确认域名可以访问后，再返回本页进行校验。'
    }
  }
}